import { HttpEvent, HttpEventType } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { BundleService } from "src/app/Services/bundleservice.service";
import { FlowQueryModel } from "src/app/models/flowquerymodel";
import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import { EventEmitterService } from "src/app/Services/event-emitter.service";

@Component({
  selector: "app-incoming-approvals",
  templateUrl: "./incoming-approvals.component.html",
  styleUrls: ["./incoming-approvals.component.scss"],
})
export class IncomingApprovalsComponent implements OnInit {
  userData: any;
  approvalRequests: any[] = [];
  inComingRequests: any[] = [];
  // status counts
  acceptedRequests: any[] = [];
  rejectedRequests: any[] = [];
  reworkPendingRequests: any[] = [];
  pendingRequests: any[] = [];
  // filters
  startDate: any;
  endDate: any;
  selectedFilter = "today";
  // progress
  progress: number;
  noResultReturned: boolean;
  rowProgress: { [key: string]: number } = {};
  flowData: any = {};
  bundleData: any = {};
  accessTypeChange: any;
  cancelledRequests: any[];
  isLoading: boolean = true;

  constructor(
    private flowService: FlowServiceService,
    private bundleService: BundleService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private eventEmitterService: EventEmitterService
  ) {}

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser") || "{}");
    
    // Set the correct menu state and page name
    this.eventEmitterService.setDashboardMenuStyleProperty("incoming-tranfer-approvals,Incoming Transfer Approvals");
    
    this.getApprovalRequestDetails();
    console.log(this.inComingRequests);
  }

  onFilterChange(filter: string) {
    this.selectedFilter = filter;
    this.applyDateFilter();
  }

  applyDateFilter() {
    if (!this.inComingRequests || !Array.isArray(this.inComingRequests)) return;
    const now = new Date();
    const arr = this.inComingRequests;
    let filtered = arr;

    switch (this.selectedFilter) {
      case "today":
        filtered = arr.filter((r) => {
          const d = new Date(r.createdDateTime);
          return (
            d.getDate() === now.getDate() &&
            d.getMonth() === now.getMonth() &&
            d.getFullYear() === now.getFullYear()
          );
        });
        break;
      case "lastDay":
        const dayAgo = new Date();
        dayAgo.setDate(now.getDate() - 1);
        filtered = arr.filter((r) => new Date(r.createdDateTime) >= dayAgo);
        break;
      case "lastWeek":
        const weekAgo = new Date();
        weekAgo.setDate(now.getDate() - 7);
        filtered = arr.filter((r) => new Date(r.createdDateTime) >= weekAgo);
        break;
      case "lastMonth":
        const monthAgo = new Date();
        monthAgo.setMonth(now.getMonth() - 1);
        filtered = arr.filter((r) => new Date(r.createdDateTime) >= monthAgo);
        break;
      case "custom":
        filtered = this.applyCustomDateFilterInternal(arr);
        break;
      default:
        filtered = [...arr];
    }

    this.inComingRequests = this.filterIncoming(filtered);
    console.log(this.inComingRequests);
    this.calculateStatusCounts(this.inComingRequests);
  }

  applyCustomDateFilterInternal(source: any[]): any[] {
    if (!this.startDate || !this.endDate) return source;
    const s = new Date(this.startDate);
    const e = new Date(this.endDate);
    return source.filter((r) => {
      if (!r || !r.createdDateTime) return false;
      const d = new Date(r.createdDateTime);
      return d >= s && d <= e;
    });
  }

  private filterIncoming(source: any[]): any[] {
    const userKey = this.userData?.emailAddress;
    return (source || []).filter(
      (req: any) => req && req.newOwnerEmail == userKey
    );
  }

  private calculateStatusCounts(source: any[]) {
    this.acceptedRequests = (source || []).filter(
      (req: any) => req && req.requestStatus === "Approved"
    );
    this.rejectedRequests = (source || []).filter(
      (req: any) =>
        req &&
        (req.requestStatus === "Rejected" ||
          req.requestStatus === "ReworkRejected")
    );
    this.reworkPendingRequests = (source || []).filter(
      (req: any) => req && req.requestStatus === "ReworkRequested"
    );
    this.cancelledRequests = (source || []).filter(
      (req: any) => req && req.requestStatus === "Cancelled"
    );
    this.pendingRequests = (source || []).filter(
      (req: any) =>
        req &&
        (req.requestStatus === "Pending" ||
          req.requestStatus === "ReworkAccepted")
    );
  }

  getApprovalRequestDetails() {
    this.isLoading = true;
    const flowQueryModel = { userEmail: this.userData.partitionKey };
    this.flowService
      .getUserTransferOwnershipDetails(
        flowQueryModel,
        this.userData.partitionKey
      )
      .subscribe((data: any) => {
        this.inComingRequests = data.filter(
          (req: any) => req && req.newOwnerEmail == this.userData.partitionKey
        );
        this.calculateStatusCounts(this.inComingRequests);

        console.log(this.inComingRequests);
        this.isLoading = false;
      });
  }

  navigateToContent(request: any) {
    if (!request) return;
    const title =
      request.contentName || request.contentTitle || request.title || "content";
    const id = request.contentId || request.rowKey || request.id;
    if (!id) {
      this.toastr.error("Unable to open content: missing id");
      return;
    }
    if (request.contentType == "Flow") {
      this.router.navigate(["/guide", this.generateUrlSlug(title), id]);
    } else if (request.contentType == "Bundle") {
      this.router.navigate(["/view-guide-pack/", id]);
    }
  }

  generateUrlSlug(html) {
    if (!html) return "";
    return html
      .replace(/<[^>]*>/g, "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .toLowerCase();
  }

  // Action button methods
  onActionClick(request: any, action: string, isIncoming: boolean) {
    if (!request) return;

    const requestKey = this.getRequestKey(request);
    if (!requestKey) {
      this.toastr.error("Unable to process request: missing identifier");
      return;
    }

    // Use ConfirmationDialogComponent for user confirmation
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "95vw",
      maxWidth: "650px",
      maxHeight: "90vh",
      data: {
        action: action,
        request: request,
        isIncoming: isIncoming,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.confirmed) {
        // Clear any existing global progress and set row-specific progress
        this.rowProgress[requestKey] = 0;

        // Prepare the ownership model for the API call
        const ownershipModel = {
          contentId: requestKey,
          requestStatus: action,
          comment: result.comment || request.comment || "",
          contentType: request.contentType,
          oldOwnerEmail: request.oldOwnerEmail,
          newOwnerEmail: request.newOwnerEmail,
        };

        // Use the postTransferOwnership method for both incoming and outgoing requests
        const serviceCall = this.flowService.postTransferOwnership(
          ownershipModel,
          this.userData.partitionKey
        );

        serviceCall.subscribe({
          next: (event: HttpEvent<any>) => {
            if (event.type === HttpEventType.UploadProgress) {
              const progress = Math.round(
                (event.loaded / (event.total || 1)) * 100
              );
              this.rowProgress[requestKey] = progress;
            } else if (event.type === HttpEventType.Response) {
              this.rowProgress[requestKey] = 100;

              // Show success message
              this.toastr.success(`Request ${action.toLowerCase()} successfully`);

              // Refresh the data
              setTimeout(() => {
                this.getApprovalRequestDetails();
              }, 1000);
            }
          },
          error: (error) => {
            console.error("Action failed:", error);
            this.toastr.error(`Failed to ${action.toLowerCase()} request`);
            delete this.rowProgress[requestKey];
          },
        });
      }
    });
  }

  // Publishing/Actions reuse from original component for incoming workflow
  getRowProgress(request: any): number {
    const key = this.getRequestKey(request);
    return key ? this.rowProgress[key] || 0 : 0;
  }

  isRowProcessing(request: any): boolean {
    const key = this.getRequestKey(request);
    if (!key) return false;
    const progress = this.rowProgress[key];
    return progress !== undefined && progress > 0 && progress < 100;
  }

  private getRequestKey(request: any): string | null {
    if (!request) return null;
    const key = request.contentId ?? request.rowKey ?? request.id;
    return key !== undefined && key !== null ? String(key) : null;
  }
}
